
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program/bnsp",
      function () {
        return require("private-next-pages/program/bnsp/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program/bnsp"])
      });
    }
  